import { add } from '../../../_modules/i18n';
import de from './de';
import fa from './fa';
import nl from './nl';
import pt_br from './pt_br';
import ru from './ru';
import sk from './sk';
import uk from './uk';
export default function () {
    add(de, 'de');
    add(fa, 'fa');
    add(nl, 'nl');
    add(pt_br, 'pt_br');
    add(ru, 'ru');
    add(sk, 'sk');
    add(uk, 'uk');
}
